import type { RouteObject } from "react-router-dom";
import DispatchPage, { dispatchLoader } from "./Dispatch";
import DispatchIndexPage from "./DispatchIndex";
import AppError from "../app-error";
import NumberRouteError from "../invoicing/number-route-error";

export const dispatchRoutes: RouteObject[] = [
  { path: "dispatch", Component: DispatchIndexPage, errorElement: <AppError /> },
  { path: "dispatch/:invoiceNumber", Component: DispatchPage, loader: dispatchLoader, errorElement: <NumberRouteError /> },
];
